import { isAxiosError } from '@data/api/errors';
import Button from '@molecules/Button';
import type { FallbackProps } from 'react-error-boundary';

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  if (error) console.error('AXIOS ERROR', error);

  let message = <h1>Something went wrong.</h1>;
  if (isAxiosError(error) && Number(error.response?.status) === 403) {
    message = (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>
          You don&apos;t have permission to access this page.
        </h2>
      </div>
    );

    return <div>{message}</div>;
  }

  return isAxiosError(error) ? (
    <div role="alert">
      <p>Something went wrong:</p>
      <h2>{error.message}</h2>
      <Button onClick={resetErrorBoundary}>Try again</Button>
    </div>
  ) : (
    <div>
      {message} {error.stack}
    </div>
  );
};

export default ErrorFallback;
